/**
 * @prettier
 * @flow
 */
export function getAccessTokenInLocalStorage(): string | void {
    const item = window.localStorage.getItem(KEY_NAME);
    return item ? JSON.parse(item) : undefined;
}

export const KEY_NAME = 'accessToken';
